module.exports = __webpack_public_path__ + "img/agent_3.a23b3f3f.png";